export default {
  tips: {
    mulStart: '用户旅程仅允许一个起点存在，当前用户旅程存在多个起点。',
    ignoreAfterInstall:
      '用户跳转后若25s内未返回可玩，则跳转之后的事件不被计入旅程分析。',
    greenPath: '绿色路径',
    greenPathDesc:
      '{greenPath}是旅程中的最大流量分支，建议基于此路径找寻优化方案或更多尝试。',
    flowsCount:
      '当从一个埋点可以到达多个埋点时，便会出现多条分支，最大流量分支则指这几条分支中最多用户经历的一条',
    dataAnomaly:
      '由于网络延迟等因素，旅程数据可能存在极小比例的异常。建议分析数据时更多关注整体趋势及百分比，并忽略这些微小误差。',
    emptyNode: '该素材未配置自定义埋点',
  },
  fields: {
    flows: '流转数',
    duration: '耗时',
    reach: '到达数',
    flowsNext: '流转到下一节点数',
    loss: '流失数',
    install: '跳转数',
  },
  basicAction: {
    imp: '广告展示',
    gs: '试玩展示',
    ws: 'Web视窗展示',
  },
  actionBar: {
    exitFullScreen: '退出全屏',
    FullScreen: '全屏',
    adjustStage: '适应画布',
  },
  projectFilter: {
    journey: {
      emptyData: '当前项目没有设置埋点，已自动为您选择了另一个有数据的项目。',
    },
    scene: {
      emptyData: '当前项目没有拆分场景，已自动为您选择了另一个有数据的项目。',
    },
    template_name: '可玩模板',
    template_name_id: '可玩模板ID',
    c_template_name: '创意方向',
    c_template_name_id: '创意方向ID',
    basic_id: '创意ID',
    mws_creative_name: '创意名称',
  },
}
